// extracted by mini-css-extract-plugin
export default {"Purpose":"Purpose_Purpose__qiNhM","PurposeBG":"Purpose_PurposeBG__Uw-EB","Wrapper":"Purpose_Wrapper__3lfN8"};